import React, { useEffect, useState } from 'react';
import './AnimatedContainer.css';

const AnimatedContainer = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [animatingLine1, setAnimatingLine1] = useState(false);
  const [animatingLine2, setAnimatingLine2] = useState(false);
  const [glowRightFor, setGlowRightFor] = useState(null);

  useEffect(() => {
    let timeout;

    if (currentStep === 1) {
      setAnimatingLine1(true);
      timeout = setTimeout(() => {
        setAnimatingLine1(false);
        setCurrentStep(prev => prev + 1);
      }, 550);
    } else if (currentStep === 3) {
      setAnimatingLine2(true);
      timeout = setTimeout(() => {
        setAnimatingLine2(false);
        setCurrentStep(prev => (prev + 1) % 5);
      }, 550);
    } else {
      setGlowRightFor(null);
      const containerToGlow = getActiveContainer();
      setTimeout(() => {
        setGlowRightFor(containerToGlow);
      }, 500);

      timeout = setTimeout(() => {
        setCurrentStep(prev => (prev + 1) % 5);
      }, 800);
    }

    return () => clearTimeout(timeout);
  }, [currentStep]);

  const getActiveContainer = () => {
    if (currentStep === 0) return 0;
    if (currentStep === 2) return 1;
    if (currentStep === 4) return 2;
    return null;
  };

  const activeContainer = getActiveContainer();

  const renderBox = (id, content) => (
    <div className={`step-box ${activeContainer === id ? 'active' : ''}`}>
      {glowRightFor === id && (
        <>
          <span className="glow-top-right animate" />
          <span className="glow-bottom-right animate" />
        </>
      )}
      {content}
    </div>
  );

  return (
    <div className="animated-containers">
      {renderBox(0, (
        <div className="code-lines">
          <div className="line short"></div>
          <div className="line medium"></div>
          <div className="line long"></div>
          <div className="launch-button"><span>🚀</span></div>
          <div className="line short"></div>
          <div className="line medium"></div>
          <div className="line medium"></div>
          <div className="line long"></div>
          <div className="line short"></div>
        </div>
      ))}

      <div className={`connecting-line ${animatingLine1 ? 'animate' : ''}`}></div>

      {renderBox(1, (
        <div className="ui-layout">
          <div className="top-bar">
            <div className="circle"></div>
            <div className="rects">
              <div className="rect"></div>
              <div className="rect"></div>
              <div className="rect"></div>
            </div>
          </div>
          <div className="main-panel"></div>
          <div className="tiles">
            <div className="tile"></div>
            <div className="tile"></div>
            <div className="tile"></div>
          </div>
        </div>
      ))}

      <div className={`connecting-line ${animatingLine2 ? 'animate' : ''}`}></div>

      {renderBox(2, (
        <div className="chart-box">
          <p className="deployed-text">✅ Deployed</p>
          <div className="chart-line red"></div>
          <div className="chart-line orange"></div>
          <div className="chart-line blue"></div>
          <div className="chart-line green"></div>
        </div>
      ))}
    </div>
  );
};

export default AnimatedContainer;